import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "relative" }

import { WorkflowNavigation, WorkflowFooter } from '@/lib/components/Workflow';
import { NotificationStack } from '@/lib/components/Notification';
import { INotification } from '@/lib';
import { SavingStatus } from '@/lib/constants';
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  PropType
} from 'vue';
import { Patient } from '@/models';
import { useNotificationStore } from '@/stores/notification.store';


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    required: true
  },

  steps: {
    type: Array,
    required: true
  },

  currentStep: {
    type: Number,
    required: true
  },

  disabled: {
    type: Boolean,
    default: false
  },

  loading: {
    type: Boolean,
    default: false
  },

  patient: {
    type: Object as PropType<Patient>,
    default: null
  },

  status: {
    type: Number,
    default: SavingStatus.UNSET
  }
},
  emits: ["complete", "cancel"],
  setup(__props, { emit }: { emit: ({
  (e: 'complete'): void;
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const top = ref(0);
const nav = ref(null);
const body = ref(null);


const notificationStore = useNotificationStore();
const notifications: INotification[] = computed(() => notificationStore.notifications);

const onScroll = () => {
  const rect = nav.value?.$el?.getBoundingClientRect();
  if (rect) {
    if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
      top.value = rect.height;
    } else {
      top.value = 0;
    }
  }
};

const onNotificationsUpdate = (notifications: INotification[]) => {
  notificationStore.notifications = notifications;
};

const handleSubmit = () => {
  emit('complete');
};

onMounted(() => {
  top.value = nav.value.$el.clientHeight;

  watch(() => props.currentStep, () => {
    body.value.scroll({
      top: 0
    });
  });

  window.addEventListener('scroll', () => onScroll());
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', () => onScroll());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "absolute inset-0 flex flex-col justify-between h-screen z-40 bg-primary-50",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _createVNode(_unref(WorkflowNavigation), {
      ref_key: "nav",
      ref: nav,
      steps: __props.steps,
      "current-step": __props.currentStep,
      patient: __props.patient,
      disabled: __props.disabled,
      loading: __props.loading,
      class: "flex-shrink-0",
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
    }, null, 8, ["steps", "current-step", "patient", "disabled", "loading"]),
    _createElementVNode("div", {
      ref_key: "body",
      ref: body,
      class: "flex-grow overflow-y-auto"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NotificationStack), {
          class: "mr-6 mt-6 z-50",
          style: _normalizeStyle('top:' + top.value + 'px;'),
          "display-items": 6,
          "model-value": _unref(notifications),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (onNotificationsUpdate($event)))
        }, null, 8, ["style", "model-value"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    _createVNode(_unref(WorkflowFooter), {
      name: __props.name,
      status: __props.status,
      loading: __props.loading
    }, {
      actions: _withCtx(() => [
        _renderSlot(_ctx.$slots, "actions")
      ]),
      _: 3
    }, 8, ["name", "status", "loading"])
  ], 40, _hoisted_1))
}
}

})